module.exports = __webpack_public_path__ + "static/media/industrial.f61eac0c.jpg";